<ng-container *ngIf="number">
  <fa-icon *ngIf="showIcon" icon="phone" pull="left"></fa-icon>
  <a [attr.href]="telHref" target="_blank">{{ number | phone }}</a>
</ng-container>
